import { Button } from 'flowbite-react';
import React from 'react';
import Timer from '../jap/Timer';
import { Img } from 'react-image';
import { useUserContext } from 'src/context/UserProvider';
import BuyProgramForInterviewOrPrep from 'src/utils/BuyInterviewOrPrep';
import moment from 'moment';

type Props = {
	onClose: () => void;
	hasAgreed: boolean;
	handleScheduleInterviewForPaidUser: () => void;
};

const DesktopPaidPaymentButtons = ({ onClose, hasAgreed, handleScheduleInterviewForPaidUser }: Props) => {
	const { user } = useUserContext();
	const interviewService = user?.evaluation?.interviewPath;
	const discountedPrice = interviewService?.offeredPrice || 0;
	const originalPrice = interviewService?.originalPrice || 0;
	const expiry = interviewService?.expiresAt;

	const hasOfferExpired = moment(expiry).isAfter();

	return (
		<div className="flex flex-row gap-3 items-center">
			{/* Expiry Timeout*/}
			<div className="flex flex-col gap-6 items-center justify-center">
				<div className="flex gap-3 items-center justify-center">
					<div className="text-sm font-medium dark:text-[#FAFAFC] font-inter">Offer valid till</div>
					<div>
						{' '}
						<Timer time={expiry || 0} />{' '}
					</div>
				</div>
			</div>

			<div className="relative">
				<BuyProgramForInterviewOrPrep
					discountedPrice={discountedPrice}
					isJapEnabled={hasAgreed}
					originalPrice={originalPrice}
					expiry={expiry}
					serviceName={'Interview Round Purchase'}
					btnText={'Schedule & Pay'}
					isForInterview={true}
					onClose={onClose}
					handleScheduleInterviewForPaidUser={handleScheduleInterviewForPaidUser}
				/>
				{hasOfferExpired ? (
					<div className="absolute right-[-10px] top-[-36px]">
						<Img src={'/assets/offerr.png'} />
					</div>
				) : null}
			</div>

			<Button color="purplePlaced" className="bg-[#273443] px-[20px] text-white" onClick={onClose}>
				Cancel
			</Button>
		</div>
	);
};

export default DesktopPaidPaymentButtons;
